import React, { useMemo } from "react";
import useResources from "../../hooks/useResources";

export const findUsername = (employees, user_id) => {
  const foundEmployee = (employees || []).find(
    (employee) => employee.id === user_id
  );

  return foundEmployee ? foundEmployee.user_name : "";
};

const UserCell = ({ data }) => {
  const { employees } = useResources();

  const user_id = useMemo(() => {
    if (data && data.data && data.data.user_id) return data.data.user_id;
  }, [data]);

  return <>{findUsername(employees, user_id)}</>;
};

export default UserCell;
